import { render, staticRenderFns } from "./VueGoogleMapsFixed.vue?vue&type=template&id=2741b658&scoped=true"
import script from "./VueGoogleMapsFixed.vue?vue&type=script&lang=js"
export * from "./VueGoogleMapsFixed.vue?vue&type=script&lang=js"
import style0 from "./VueGoogleMapsFixed.vue?vue&type=style&index=0&id=2741b658&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2741b658",
  null
  
)

export default component.exports